import React from "react";
import { Table, Space, Tag } from "antd";
import { capitalizeFirstLetter } from "../../../helpers/utility";
import dayjs from "dayjs";

const MyAppointmentsTable = ({ data }) => {
  const columns = [
    {
      title: "Slot",
      dataIndex: "appointment_time",
      key: "appointment_time",
      render: (value) => {
        return dayjs(value, "HH:mm:ss").format("hh:mm A");
      },
    },
    {
      title: "Patient ID",
      dataIndex: ["patient", "patient_id"],
      key: "patient_id",
      render: (value) => value || "-",
    },
    {
      title: "Patient Name",
      key: "patient_name",
      render: (_, record) => {
        const name = [record?.patient?.first_name, record?.patient?.last_name]
          .filter(Boolean)
          .map((part) => capitalizeFirstLetter(part))
          .join(" ");
        return <Space>{name || "-"}</Space>;
      },
    },
    {
      title: "Contact Number",
      dataIndex: ["patient", "mobile"],
      key: "patient_mobile",
      render: (value) => value || "-",
    },
    {
      title: "Age",
      key: "patient_age",
      render: (_, record) =>
        record?.patient?.age ?? record?.patient?.age_by_dob ?? "-",
    },
    {
      title: "Appointment For",
      dataIndex: "appointment_for",
      key: "appointment_for",
      render: (value) =>
        value === "consultation" ? (
          <Tag color="purple">Consultation</Tag>
        ) : (
          <Tag color="blue">Session</Tag>
        ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (value) =>
        value === "scheduled" ? (
          <Tag color="green">Scheduled</Tag>
        ) : (
          value === "reported" && <Tag color="orange">Reported</Tag>
        ),
    },
  ];
  return (
    <Table
      columns={columns}
      dataSource={data?.data}
      bordered
      pagination={false}
    />
  );
};

export default MyAppointmentsTable;
